module.exports = __webpack_public_path__ + "img/logo_oerag_immobilien.d6904337.svg";